import {get, post, put} from '@/services/infrastructure/api.service'
import {Dimension, DimensionType} from '@/dimensions/Dimension'
import emitter from '@/services/infrastructure/emitter'
import {LOGOUT, NO_ORG_SELECTED, ORG_SELECTED, ORG_SWITCHED} from '@/types/events'
import {computed, ref} from 'vue'

const DIMENSIONS_PATH = '/dimensions'
const dimensions = ref<Array<Dimension>>([])
const projects = computed(() => dimensions.value.filter(d => d.type === DimensionType.PROJECT && d.isEnabled))
const departments = computed(() => dimensions.value.filter(d => d.type === DimensionType.DEPARTMENT && d.isEnabled))

const DIMENSION_CREATED = 'dimensionCreated'
const DIMENSION_UPDATED = 'dimensionUpdated'

export type Department = Dimension & {
    type: DimensionType.DEPARTMENT
}

export type Project = Dimension & {
    type: DimensionType.PROJECT
}

const fetchDimensions = async (date: Date | null = null): Promise<Array<Dimension>> => {
    return await get<Array<Dimension>>(DIMENSIONS_PATH, {date}) ?? []
}

const createDimension = async (dimension: Dimension): Promise<Dimension | undefined> => {
    const savedDimension = await post(DIMENSIONS_PATH, dimension)
    dimensions.value = [...dimensions.value, savedDimension]
    return savedDimension
}

const putDimension = async (dimension: Dimension): Promise<Dimension | undefined> => {
    return await put(DIMENSIONS_PATH, dimension)
}

const init = async () => {
    if (!dimensions.value?.length) {
        dimensions.value = await fetchDimensions()
    }
}

const fetch = async () => {
    dimensions.value = await fetchDimensions()
}

const clear = async () => {
    dimensions.value = []
}

emitter.on(ORG_SWITCHED, fetch)
emitter.on(DIMENSION_CREATED, fetch)
emitter.on(DIMENSION_UPDATED, fetch)
emitter.on(ORG_SELECTED, init)
emitter.on(NO_ORG_SELECTED, clear)
emitter.on(LOGOUT, clear)

const useDimensions = () => {

    const newProject = (name: string): Project => {
        return {
            name,
            isEnabled: true,
            type: DimensionType.PROJECT
        }
    }

    const newDepartment = (name: string): Department => {
        return {
            name,
            isEnabled: true,
            type: DimensionType.DEPARTMENT
        }
    }

    return {
        fetchDimensions,
        createDimension,
        putDimension,
        fetch,
        dimensions,
        projects,
        departments,
        newProject,
        newDepartment,
    }
}
export {
    fetchDimensions,
    createDimension,
    putDimension,
    useDimensions
}